export default {
  // Loading
  loading: "Loading...",

  // No Data
  noData: "No Data",

  // Titles
  pendingSurvey: "Pending Survey",
  completedSurvey: "Completed Survey",

  // Field Labels
  platform: "Platform: ",
  platformColon: "Platform:",
  surveyContent: "Survey Content: ",
  uid: "UID: ",
  name: "Name: ",
  address: "Address: ",

  // Buttons
  uploadSurvey: "Upload Survey",
  downloadSurveyContent: "Download Survey Content",
  dataSync: "Data Sync",

  // Messages
  messageTitle: "Message",
  dataSyncing: "Data syncing, please check later",

  // File Name
  dataFileName: "Data",
};
